import { CONSENTS } from '@/services/consents/constants';
import type { GetConsentResponseType } from '@/services/consents/types';

export const getConsentData: GetConsentResponseType = async consentGroup =>
    await fetch(`${CONSENTS}?filter[groupName][]=${consentGroup}`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    }).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });
